var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleButtonover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Circle_Button_over",
    "data-name": "Circle Button over",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bbe46c;\n      }\n\n      .cls-2 {\n        fill: rgba(253,73,198,0.35);\n        opacity: 0;\n      }\n\n      .cls-3 {\n        fill: #2f2f2f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    className: "cls-1",
    width: 48,
    height: 48,
    rx: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ICON_feather_facebook_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Icon [ICON=feather/facebook][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_ICON:feather_facebook_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [ICON:feather/facebook][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]",
    className: "cls-2",
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.833 1.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_410c6255-99eb-4291-8131-c2528dd6aff4",
    "data-name": "410c6255-99eb-4291-8131-c2528dd6aff4",
    className: "cls-3",
    d: "M15,1h3a1,1,0,0,1,1,1V6a1,1,0,0,1-1,1H15V9h3a1,1,0,0,1,.97,1.243l-1,4A1,1,0,0,1,17,15H15v7a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V15H7a1,1,0,0,1-1-1V10A1,1,0,0,1,7,9H9V7A6.007,6.007,0,0,1,15,1Zm2,2H15a4,4,0,0,0-4,4v3a1,1,0,0,1-1,1H8v2h2a1,1,0,0,1,1,1v7h2V14a1,1,0,0,1,1-1h2.219l.5-2H14a1,1,0,0,1-1-1V7a2,2,0,0,1,2-2h2Z",
    transform: "translate(-8.333 -3.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleButtonover);
export default __webpack_public_path__ + "static/media/Circle Button over.d1703a9b91a355a1f57bd88e744b2caa.svg";
export { ForwardRef as ReactComponent };